<template>
  <div :class="modalTheme">
    <div :class="userStore.borderClass" style="padding-right: 5px; height: 35px">
      <!-- <h6>modalTheme: {{ modalTheme }}</h6> -->

      <b-form-group :class="modalTheme">
        <b-form-select :class="modalTheme" v-model="selectedDevTheme" :options="devExtremeThemes" value-field="value" text-field="label" size="sm" class="mb-0"></b-form-select>
      </b-form-group>
      <!-- selectedDevTheme: {{ selectedDevTheme }} -->
      <!-- Theme selector dropdown using b-form-select -->
      <!-- <b-form-group label-for="theme-select" style="width: 150px;" :class="modalTheme">
      <b-form-select :class="modalTheme" id="theme-select" v-model="selectedTheme"    :options="modalThemes" value-field="value" text-field="label" size="sm" class="mb-0"></b-form-select>
    </b-form-group> -->
      <!-- {{ selectedTheme }} -->

      <!-- <b-button :class="[modalTheme, 'no-wrap']" active-class="" pill @click="toggleTheme" :variant="isDarkTheme ? 'dark' : 'light'" size="sm" class="theme-toggle-button">
      <font-awesome-icon :icon="isDarkTheme ? ['far', 'moon'] : ['fas', 'sun']" size="lg" :style="{ color: isDarkTheme ? 'yellow' : '#dcf1de' }" />
      <span>{{ isDarkTheme ? " Dark Theme" : " Light Theme" }}</span>
    </b-button> -->
      <b-row v-if="AreIdsShown" class="mb-0">
        <b-col cols="*">
          <VueToggles @click="toggleTheme" :value="isDarkTheme" :width="55" :height="15" :margin="1" checkedText="Dark" uncheckedText="Light" checkedBg="#6e796f" uncheckedBg="#b0c1b2" />
        </b-col>
        <b-col cols="*">
          <font-awesome-icon v-if="isDarkTheme" :icon="['far', 'moon']" size="lg" style="color: yellow" />
          <font-awesome-icon v-else :icon="['fas', 'sun']" size="lg" style="color: red" />
        </b-col>
      </b-row>

      <br />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { setUserSessionVariable, fetchSessionVariable } from "@/api/userApi";

import themes, { init } from "devextreme/ui/themes";

// & COMPOSIBLEs
import { devExtremeThemes } from "@/use/themeUtils.js";

import { VueToggles } from "vue-toggles";

const selectedDevTheme = ref(devExtremeThemes[0].value);

const borderClass = computed(() => {
  switch (modalTheme.value) {
    case "generic-light-modal":
      return "generic-light-border";
    case "generic-dark-modal":
      return "generic-dark-border";
    case "generic-light-blue-modal":
      return "generic-light-blue-border";
    case "generic-dark-blue-modal":
      return "generic-dark-blue-border";
    case "generic-light-green-modal":
      return "generic-light-green-border";
    case "generic-dark-green-modal":
      return "generic-dark-green-border";
    case "generic-light-yellow-modal":
      return "generic-light-yellow-border";
    case "generic-dark-yellow-modal":
      return "generic-dark-yellow-border";
    case "generic-light-orange-modal":
      return "generic-light-orange-border";
    case "generic-dark-orange-modal":
      return "generic-dark-orange-border";
    case "generic-light-red-modal":
      return "generic-light-red-border";
    case "generic-dark-red-modal":
      return "generic-dark-red-border";
    case "generic-light-white-modal":
      return "generic-light-white-border";
    default:
      return "";
  }
});

const modalTheme = computed(() => userStore.bModalTheme);
const modalThemes = [
  { label: "Light White", value: "generic-light-white-modal", lsb: "light-white-theme" },
  { label: "Light", value: "generic-light-modal", lsb: "white-theme" },
  { label: "Dark", value: "generic-dark-modal", lsb: "dark" },
  { label: "Light Blue", value: "generic-light-blue-modal", lsb: "light-blue-theme" },
  { label: "Dark Blue", value: "generic-dark-blue-modal", lsb: "blue-theme" },
  { label: "Light Green", value: "generic-light-green-modal", lsb: "light-green-theme" },
  { label: "Dark Green", value: "generic-dark-green-modal", lsb: "green-theme" },
  { label: "Light Yellow", value: "generic-light-yellow-modal", lsb: "light-yellow-theme" },
  { label: "Dark Yellow", value: "generic-dark-yellow-modal", lsb: "yellow-theme" },
  { label: "Light Orange", value: "generic-light-orange-modal", lsb: "light-orange-theme" },
  { label: "Dark Orange", value: "generic-dark-orange-modal", lsb: "orange-theme" },
  { label: "Light Red", value: "generic-light-red-modal", lsb: "white-theme" },
  { label: "Dark Red", value: "generic-dark-red-modal", lsb: "light-red-theme" },
];

const selectedTheme = computed({
  get: () => userStore.bModalTheme,
  set: async (val) => {
    userStore.bModalTheme = val;

    // Find the lsbTheme for the selected modal theme
    const found = modalThemes.find((t) => t.value === val);
    userStore.lsbTheme = found ? found.lsb : "light-white-theme";

    // console.log("Setting selectedTheme to:", val);
  },
});

watch(selectedDevTheme, async (val) => {
  const found = devExtremeThemes.find((t) => t.value === val);
  if (found) {
    // console.log(" VAL : ", val);
    // console.log("Found theme:", found);

    userStore.bModalTheme = found.modal;
    userStore.lsbTheme = found.lsb;
    userStore.devExTheme = found.value;
    themes.current(found.value);

    // console.log("   SAVIING  theme to localStorage  : ", found.value);
    window.localStorage.setItem("dx-theme", found.value);

    // console.log(" _____________________________________________      THEMES        ______________________");
    // save devextheme to setUserSessionVariable
    const tPayload = { variableName: "devExTheme", variableValue: userStore.devExTheme };
    // console.log("tPayload ");
    // console.log(tPayload);
    await setUserSessionVariable(tPayload);

    // console.log("Updating Single USER variable :  devExTheme");
    // console.log("Fetch fetchSessionVariable ");
    const tdevExTheme = await fetchSessionVariable("devExTheme");
    // console.log(tdevExTheme);

    userStore._user.devExTheme = tdevExTheme.payload;
  }
});

const AreIdsShown = ref(false);
// Reactive variable to store the selected theme
// const selectedTheme = ref("generic.light");

// const isDarkTheme = ref(false);
const isDarkTheme = computed({
  get: () => userStore.bModalTheme === "generic-dark-modal",
  set: async (val) => {
    // console.log("Setting isDarkTheme to:", val);

    init();
    const newTheme = val ? "generic.dark" : "generic.light.white";

    if (!newTheme) {
      console.error("Error: newTheme is null or undefined in computed setter");
      return;
    }

    userStore.devExTheme = newTheme;
    userStore.lsbTheme = val ? "dark" : "light-white-theme";
    userStore.bModalTheme = val ? "generic-dark-modal" : "generic-light-modal";
    // // Save to localStorage in the setter (side effect is OK here)
    localStorage.setItem("dx-theme", newTheme);
    // console.log("Theme saved to localStorage in computed setter:", newTheme);
    if (newTheme === null || newTheme === undefined) {
      // console.error("                         Error: newTheme is null or undefined in computed setter");
    }
    themes.current(userStore.devExTheme);
    // // console.log("                savedTheme in localStorage:", localStorage.getItem("savedTheme"));
  },
});

// Function to toggle the theme

const toggleTheme = () => {
  isDarkTheme.value = !isDarkTheme.value;
  const newTheme = isDarkTheme.value ? "generic.dark" : "generic.light.white";
  switchTheme(newTheme);

  // const newTheme = isDarkTheme.value ? "generic.dark" : "generic.light";
  // themes.current(newTheme);
  // console.log("Theme switched to:", newTheme);

  // console.log(" ________________update store props____________________________________________________SAVING devExTheme and lsbTheme to USER STORE");
  // // console.log("  devExTheme :", newTheme);
  userStore.devExTheme = newTheme;

  const lsbTheme = isDarkTheme.value ? "dark" : "light-white-theme";
  userStore.lsbTheme = lsbTheme;
  // // console.log("  lsbTheme :", lsbTheme);

  const bModalTheme = isDarkTheme.value ? "generic-dark-modal" : "generic-light-modal";

  userStore.bModalTheme = bModalTheme;
  // // console.log("  bModalTheme :", bModalTheme);
};
function switchTheme(themeName) {
  if (!themeName || typeof themeName !== "string") {
    // console.error("Invalid theme name:", themeName);
    return;
  }
  // console.log("Switching theme to:", themeName);
  window.localStorage.setItem("dx-theme", themeName);
  themes.current(themeName);
}

// Ensure the correct theme is applied on component mount
onMounted(() => {
  // console.log("OnMounted: ThemeToggle component mounted. Current theme:", isDarkTheme.value ? "Dark" : "Light");

  // // * Load the theme from localStorage, fallback to generic.light if not found
  // const themeName = window.localStorage.getItem("dx-theme") || "generic.light";
  // console  .log("OnMounted: Loaded theme from localStorage:", themeName);
  // themes.current("generic.light");

  // // Find the theme object from devExtremeThemes
  const found = devExtremeThemes.find((t) => t.value === userStore._user.devExTheme);
  if (found) {
    selectedDevTheme.value = found.value;
    userStore.bModalTheme = found.modal;
    userStore.lsbTheme = found.lsb;
    userStore.devExTheme = found.value;
  } else {
    // fallback to default
    selectedDevTheme.value = devExtremeThemes[0].value;
    userStore.bModalTheme = devExtremeThemes[0].modal;
    userStore.lsbTheme = devExtremeThemes[0].lsb;
    userStore.devExTheme = devExtremeThemes[0].value;
  }
});
</script>

<style scoped>
/* Add any styles for the theme toggle component */
label {
  margin-right: 10px;
  font-weight: bold;
}
select {
  padding: 5px;
  font-size: 14px;
}
</style>
